var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSdsIconAnimation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "normal",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "wasm-icon-fill",
    d: "m32,9.67c12.31,0,22.33,10.02,22.33,22.33s-10.02,22.33-22.33,22.33-22.33-10.02-22.33-22.33,10.02-22.33,22.33-22.33m0-4c-14.54,0-26.33,11.79-26.33,26.33s11.79,26.33,26.33,26.33,26.33-11.79,26.33-26.33S46.54,5.67,32,5.67h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "wasm-icon-fill",
    d: "m43.28,30.71l-17.69-10.21c-.99-.57-2.24.14-2.24,1.29v20.42c0,1.15,1.24,1.87,2.24,1.29l17.69-10.21c.99-.57.99-2.01,0-2.59Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdsIconAnimation);
export default __webpack_public_path__ + "static/media/SDS_icon_Animation.f5172bda8210742814c6fcc63809c9ee.svg";
export { ForwardRef as ReactComponent };